import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import moment from 'moment'
import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    InputNumber,
    List,
    notification,
    Popconfirm,
    Row,
    Select,
    Table,
    Tabs,
    Tag,
    Tooltip,
    Upload,
    Divider,
    Modal
} from 'antd'
import _ from 'lodash'

import { hideLoader, showLoader } from '../../../../modules/actions'
import Quali from '../../../../components/qualification'

import Request, { API_URL } from '../../../../request'
import { connect } from 'react-redux'
import style from './styles.less'
import styles from '../../../../components/_utils/masterDoc.less'
import RadioButton from 'antd/lib/radio/radioButton'
import async from 'async'

const Option = Select.Option
const { TextArea } = Input

const TabPane = Tabs.TabPane
// following variables needed for update country
let docLoaded = null
let courseId = null
let oldUniId = null
let idsArr = []

const { MonthPicker } = DatePicker

@Form.create()
class AddCourse extends PureComponent {

    handleMove = e => {
        e.preventDefault();
    }

    handleSubmit = e => {
        e.preventDefault()
        const { dispatch, form } = this.props
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                values.intakes = this.state.intakes
                values.campusIds = this.state.campusIds
                values.ieltsRequirements = this.state.ieltsRequirements
                values.academicRequirements = this.state.academicRequirements
                values.pathways = this.state.pathways
                values.qualification = this.state.list
                values.ieltsScoreAcceptable = this.state.ieltsScoreAcceptable;
                values.bachelorDegreeAcceptable = this.state.bachelorDegreeAcceptable;

                if (this.state.tutionFeeList && this.state.tutionFeeList.length) {
                    values.tutionFeeList = this.state.tutionFeeList;
                }

                if (courseId) {
                    values = { ...values, _id: courseId }

                    dispatch(showLoader())
                    let x = await Request.updateCourse(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                    this.setFormValues(courseId)

                } else {
                    dispatch(showLoader())
                    dispatch(hideLoader())
                    let x = await Request.addCourse(values)
                    console.log(x);
                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()
                        this.setState({
                            ieltsRequirements: [],
                            academicRequirements: [],
                            campusIds: [],
                            pathways: [],
                            intakes: [],
                            campArr: []
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }
    callback = key => {
        if (key == 6) {
            this.setState({ showSave: 0 })
        } else {
            this.setState({ showSave: 1 })
        }

        setTimeout(() => {
            this.props.form.setFieldsValue(docLoaded);
        }, 50)



    }

    changeIeltsScoreAcceptable = (e) => {
        this.setState({
            ieltsScoreAcceptable: e.currentTarget.value == 'true' ? true : false
        });
    }

    changeBachelorDegreeAcceptable = (e) => {
        this.setState({
            bachelorDegreeAcceptable: e.currentTarget.value == 'true' ? true : false
        });
    }

    addToIntake = () => {
        if (this.state.intakeVal != undefined && this.state.intakeVal != null) {
            let tempArr = this.state.intakes
            let findIntake = tempArr.find((obj) => {
                let objOld = moment(obj).startOf('month').format('MMM')
                let newObj = moment(this.state.intakeVal).startOf('month').format('MMM')
                if (objOld === newObj) {
                    return true
                }
            })
            if (findIntake) {
                notification.error({
                    message: 'Error',
                    description: 'Duplicate Intake'
                })
                return
            }
            tempArr.push(moment(this.state.intakeVal))
            this.setState({ intakes: tempArr, intakeVal: null })
        } else {
            notification.error({
                message: "Error",
                description: "Please select intake first!!!.",
            });
        }
    }
    loadUniversities = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ universityList: resp.arr }, () => {
                    this.refreshFxn()
                })
            })
            .catch(err => {
                console.log(err)
            })
    }

    getUniversityDetail = async uniId => {
        let university = await Request.getUniversity(uniId);
        let universityDetail = university && university.doc;
        let currency;
        if (universityDetail && (universityDetail.universityCurrency || universityDetail.currencyName)) {
            currency = universityDetail.universityCurrency ? universityDetail.universityCurrency : universityDetail.currencyName
        }

        let campArr = universityDetail.campus.reduce((temp, vv) => {
            if (!vv.deleted) {
                temp.push({ _id: vv._id, campusName: vv.campusName || "" });
                return temp;
            }
        }, []);
        this.setState({ currency, universityDetail, campArr, selectedRowKeys: this.state.campusIds });
    }


    state = {
        showSave: 1,
        showFiles: 0,
        selectedRowKeys: [],
        refreshChild: false,
        examType: '',
        fileDescription: '',
        fileBranches: '',
        files: [],
        arr: [],
        showEntryRequirements: null,
        showQualificationEntry: null,
        editIeltsIndex: 'false',
        allTestTypes: [],
        courseId: '',
        ieltsScoreAcceptable: false,
        universityDetail: {},
        bachelorDegreeAcceptable: false,
        typeOfDegree: [],
        ieltsRequirements: [],
        academicRequirements: [],
        campusIds: [],
        pathways: [],
        intakes: [],
        campArr: [],
        list: [],
        universityList: [],
        facultyArr: [],
        levelArr: [],
        tutionFeeStructure: null,
        tutionFeeList: [],
        showFeeModal: false
    }
    loadFaculties = async () => {
        let params = { sortField: 'facultyName', sortOrder: 'ascend' }
        Request.loadSimpleFaculties({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.facultyName })
                    return temp
                }, [])

                this.setState({ facultyArr: resp.data }, () => {
                    this.refreshFxn()
                });

            })
            .catch(err => {
                console.log(err)
            })
    }
    loadLevels = async () => {
        let params = { sortField: 'levelName', sortOrder: 'ascend' }
        Request.loadSimpleLevels({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.levelName })
                    return temp
                }, [])
                this.setState({ levelArr: resp.data }, () => {
                    this.refreshFxn()
                });

            })
            .catch(err => {
                console.log(err)
            })
    }

    onSave = (index) => {
        const { form } = this.props
        let x = form.getFieldsValue(['qualification', 'gradingSystem', 'qualificationStatus', 'score', 'percentage', 'maths', 'english', 'stream', 'major', 'passingYear', 'backlogs', 'board', 'degreeType'])
        let editedData = [...this.state.list]
        editedData[index] = { ...x }
        this.setState({ list: editedData }, () => {
        })

    }
    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }
    removeIn = sss => {
        let arr = this.state.intakes
        arr = _.reject(arr, val => {
            return val == sss
        })
        this.setState({ intakes: arr })
    }

    setFormValues = async (courseId) => {
        oldUniId = null
        console.log(courseId);
        try {
            let { doc } = await Request.getCourse(courseId);
            let { campusIds } = await Request.getCourseCampus(courseId);
            if (doc) {
                oldUniId = doc._id;
                this.getUniversityDetail(oldUniId)
                docLoaded = doc.course
                docLoaded.universityId = oldUniId
                if (campusIds && campusIds.length) {
                    idsArr = campusIds
                }
                if (docLoaded.campusIds) {
                    this.setState({ campusIds: docLoaded.campusIds })
                }

                if (docLoaded.tutionFeeStructure) {
                    this.setState({ tutionFeeStructure: docLoaded.tutionFeeStructure })
                }

                if (docLoaded.tutionFeeList && docLoaded.tutionFeeList.length) {
                    this.setState({ tutionFeeList: docLoaded.tutionFeeList })
                }

                if (docLoaded.ieltsRequirements) {
                    this.setState({ ieltsRequirements: docLoaded.ieltsRequirements })
                }
                if (docLoaded.academicRequirements) {
                    this.setState({
                        academicRequirements: docLoaded.academicRequirements
                    })
                }

                if (docLoaded.intakes) {
                    this.setState({ intakes: docLoaded.intakes })
                }
                if (docLoaded.pathways) {
                    this.setState({ pathways: docLoaded.pathways })
                }

                if (docLoaded.ieltsScoreAcceptable) {
                    this.setState(
                        { ieltsScoreAcceptable: docLoaded.ieltsScoreAcceptable })
                }
                if (docLoaded.bachelorDegreeAcceptable) {
                    this.setState(
                        { bachelorDegreeAcceptable: docLoaded.bachelorDegreeAcceptable })
                }

                if (docLoaded.qualification && docLoaded.qualification.length) {
                    this.setState({ list: docLoaded.qualification })
                }

                setTimeout(() => {
                    this.props.form.setFieldsValue(docLoaded);
                }, 50)


            }
        } catch (error) {
            console.log(error);
        }
    }
    onSelectChange = (selectedRowKeys, selectedRows) => {

        let tempArr = selectedRows.reduce((arr, temp) => {
            arr.push(temp._id)
            return arr
        }, [])

        this.setState({ campusIds: tempArr, selectedRowKeys: selectedRowKeys })
    }

    saveFiles = () => {
        const { dispatch, form } = this.props
        let { files, fileDescription, fileBranches } = this.state
        if (!fileDescription) {
            return notification.error({ message: 'Expect fileDescription' })
        }
        if (!fileBranches) {
            return notification.error({ message: 'Expect fileBranches' })
        }

        if (!files.length) {
            return notification.error({ message: 'Expect file' })
        }
        let obj = {
            files: files,
            description: fileDescription,
            branch: fileBranches,
            universityId: oldUniId,
            courseId: courseId,
            type: 'Course'
        }


        Request.saveFileLibraryData(obj)
            .then(resp => {
                if (resp.success) {
                    this.loadDocs()
                    this.setState({
                        fileDescription: '',
                        fileBranches: '',
                        files: [],
                        file: ''
                    })
                    this.onRemove()
                    return notification.success({
                        message: 'Success',
                        description: resp.msg
                    })
                }
                if (resp.error) {
                    return notification.error({ message: 'Error', description: resp.msg })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadTestTypes = async () => {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getAllTestTypes(params)
        this.setState({ allTestTypes: response.data })
    }
    loadDocs = () => {
        Request.getFileLibraryByCourseId(courseId).then(resp => {
            if (resp.success) {

                _.each(resp.doc, (item) => {

                    _.each(item.files, val => {
                        item.link = API_URL + '/' + val.url
                        item.name = val.name
                    })

                })
                this.setState({ arr: resp.doc }, () => {

                })
            }
        })
    }

    handleDelete = (val) => {
        let obj = {
            courseId: courseId,
            mediaId: val
        }

        Request.deleteCourseMediaFiles(obj)
            .then(x => {
                if (x.success) {
                    this.loadDocs()
                    return notification.success({
                        message: x.msg
                    })
                } else {
                    return notification.error({ message: 'Error', description: x.msg })
                }
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }


    handleChange = v => {
        if (v.fileList) {
            this.setState({ files: v.fileList })
        }
    }

    changeShowEntryRequirement = (value) => {
        this.setState({ showEntryRequirements: value })
        if (value === true) {
            let { universityDetail } = this.state
            this.setState({ ieltsRequirements: universityDetail.ieltsRequirements, ieltsScoreAcceptable: universityDetail.ieltsScoreAcceptable, bachelorDegreeAcceptable: universityDetail.bachelorDegreeAcceptable })
        } else {
            this.setState({ ieltsRequirements: [], ieltsScoreAcceptable: false, bachelorDegreeAcceptable: false })
        }
    }

    changeShowQualificationRequirement = (value) => {
        this.setState({ showQualificationEntry: value })
        if (value) {
            this.setState({ list: this.state.universityDetail.qualification })
        }
    }

    onRemove = v => {

    }
    editIeltsRequirement = (index, record) => {
        this.setState({ editIeltsIndex: index, examType: record.ExamType, listening: record.Listening, overall: record.Overall, reading: record.Reading, speaking: record.Speaking, writing: record.Writing })
    }
    updateIeltsRequirement = () => {
        let { editIeltsIndex, examType, listening, reading, overall, speaking, writing, ieltsRequirements } = this.state;
        if (ieltsRequirements[editIeltsIndex] == undefined) {
            ieltsRequirements[editIeltsIndex] = [];
        }
        ieltsRequirements[editIeltsIndex].ExamType = examType
        ieltsRequirements[editIeltsIndex].Overall = overall
        ieltsRequirements[editIeltsIndex].Listening = listening
        ieltsRequirements[editIeltsIndex].Reading = reading
        ieltsRequirements[editIeltsIndex].Writing = writing
        ieltsRequirements[editIeltsIndex].Speaking = speaking;
        this.setState({ editIeltsIndex: 'false', ieltsRequirements: ieltsRequirements, examType: '', listening: '', overall: '', reading: '', speaking: '', writing: '' });
    }
    constructor(props) {
        super(props)
        this.loadUniversities()
        this.loadFaculties()
        this.loadLevels()
        this.loadDegrees()
    }

    loadDegrees = async () => {
        let params = {
            sortField: "degreeName",
            sortOrder: "ascend",
            deleted: false,
            results: 10000,
            count: 10000
        }
        let response = await Request.getAllTypeOfDegrees(params);
        let typeOfDegree = {
            'Diploma': [],
            'Bachelor Degree': [],
            'masters': []
        }
        async.each(response.data, (item) => {
            if (item.qualification === "Bachelor Degree") {
                typeOfDegree["Bachelor Degree"].push({ key: item.degreeName, value: item.degreeName })
            } else if (item.qualification === "Diploma") {
                typeOfDegree["Diploma"].push({ key: item.degreeName, value: item.degreeName })
            } else if (item.qualification === "Masters" || item.qualification === "Master Degree") {
                typeOfDegree["masters"].push({ key: item.degreeName, value: item.degreeName })
            }
        })
        this.setState({ typeOfDegree })
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        courseId = searchParams.get('id')
        if (courseId) {
            this.setState({ showFiles: 1, showEntryRequirements: true, courseId: courseId })
            this.loadDocs()
            this.setFormValues(courseId)
        }
        this.loadTestTypes()
        setTimeout(() => {
        }, 2000)
    }

    handleFeeDetailSubmit = () => {
        let { form } = this.props;

        let feeValues = form.getFieldsValue([
            'feeYear',
            'yearTutionFee',
            'yearScholarship',
            'yearMaterialFee',
            'yearUniformFee',
            'yearInsuranceFee',
            'yearOtherFee'
        ])

        if (!feeValues.feeYear) {
            notification.error({ message: 'Expect Tution Fee Year!' });
            return;
        }
        if (!feeValues.yearTutionFee) {
            notification.error({ message: 'Expect Tution Fee Amount!' });
            return;
        }
        let tutionFeeList = [...this.state.tutionFeeList];
        tutionFeeList.push({ ...feeValues });


        this.setState(
            {
                tutionFeeList,
                showFeeModal: false,
            },
            () => {
                this.props.form.setFieldsValue({
                    feeYear: null,
                    yearTutionFee: null,
                    yearScholarship: null,
                    yearMaterialFee: null,
                    yearUniformFee: null,
                    yearOtherFee: null,
                });
            }
        );
    }

    render() {
        const { submitting, form: { setFieldsValue } } = this.props
        const { selectedRowKeys, intakes, list, showEntryRequirements, showQualificationEntry, typeOfDegree } = this.state;
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props

        const { universityList, facultyArr, levelArr, currency, tutionFeeStructure, tutionFeeList, showFeeModal } = this.state

        let inputs = [
            {
                tabTitle: 'General Info',
                fields: [
                    {
                        label: 'Select University ',
                        key: 'universityId',
                        required: true,
                        type: 'select',
                        showSearch: true,
                        disabled: false,
                        options: universityList,
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                universityId: v
                            })
                            this.getUniversityDetail(v)
                        }
                    },
                    { label: 'Course Name', key: 'courseName', required: true },
                    { label: 'Course Code', key: 'courseCode', required: true },
                    { label: 'Duration ', key: 'courseDuration', required: true },

                    {
                        label: 'Select Level ',
                        key: 'courseLevelId',
                        required: true,
                        showSearch: true,
                        type: 'select',
                        options: levelArr,
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                courseLevelId: v
                            })
                        }
                    },
                    {
                        label: 'Select Faculty',
                        key: 'courseFacultyId',
                        required: true,
                        showSearch: true,
                        type: 'select',
                        options: facultyArr,
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                courseFacultyId: v
                            })
                        }
                    },
                    {
                        label: 'Awarding Body ',
                        key: 'courseAwardingBody',
                        required: true
                    },
                    { label: 'Course Url', key: 'courseURL', required: true }
                ]
            },
            {
                tabTitle: 'Fee Details',
                fields: [
                    {
                        label: 'Tuition Fee Structure',
                        key: 'tutionFeeStructure',
                        type: 'select',
                        options: [{ _id: 'Fixed', display: 'Fixed fee for all years' }, { _id: 'Year-wise', display: 'Fee varies by year' }],
                        required: true,
                        onChange: v => {
                            setFieldsValue({ tutionFeeStructure: v }, () => {
                                this.setState({ tutionFeeStructure: v });
                            })
                        }
                    },
                    { label: `Tuition Fee per year ${currency ? `(${currency})` : ''}`, key: 'tutionFee', hidden: tutionFeeStructure !== "Fixed", required: tutionFeeStructure === "Fixed" },
                    { label: `Scholarship if any ${currency ? `(${currency})` : ''}`, key: 'scholarship', hidden: tutionFeeStructure !== "Fixed" },
                    { label: `Material Fee ${currency ? `(${currency})` : ''}`, key: 'materialFee', hidden: tutionFeeStructure !== "Fixed", },
                    { label: `Uniform Fee ${currency ? `(${currency})` : ''}`, key: 'uniformFee', hidden: tutionFeeStructure !== "Fixed", },
                    { label: `Insurance Fee ${currency ? `(${currency})` : ''}`, key: 'insuranceFee', hidden: tutionFeeStructure !== "Fixed", },
                    { label: `Other Fee ${currency ? `(${currency})` : ''}`, key: 'otherFee', hidden: tutionFeeStructure !== "Fixed", },
                    {
                        label: 'Payable',
                        key: 'payable',
                        type: 'select',
                        options: ['Semester wise', 'Annual', 'Trimester'],
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                payable: v
                            })
                        }
                    },
                    {
                        label: 'Additional Requirements',
                        key: 'additionalRequirements',
                        type: 'textArea',
                        rows: '5'
                    }
                ]
            },
            {
                tabTitle: 'Campus / Intakes ',
                fields: []
            },
            {
                tabTitle: 'Pathways',
                fields: []
            },
            {
                tabTitle: 'Entry Requirements',
                fields: []
            }

        ];

        const ieltsColumn = [
            { title: 'Exam', key: 'examType', dataIndex: 'ExamType' },
            { title: 'Overall', key: 'overall', dataIndex: 'Overall' },
            { title: 'Listening', key: 'listening', dataIndex: 'Listening' },
            { title: 'Reading', key: 'reading', dataIndex: 'Reading' },
            { title: 'Writing', key: 'writing', dataIndex: 'Writing' },
            { title: 'Speaking', key: 'speaking', dataIndex: 'Speaking' },
            {
                title: 'Action',
                key: 'action',
                dataIndex: 'action',
                render: (val, record, index) => {
                    return (
                        <>
                            <a
                                size="small"
                                onClick={() => { this.editIeltsRequirement(index, record) }}>
                                Edit
                            </a>&nbsp;|&nbsp;
                            <a
                                size="small"
                                onClick={() => {
                                    let tempArr = _.reject(this.state.ieltsRequirements, val => {
                                        return val == record
                                    })
                                    this.setState({ ieltsRequirements: tempArr })
                                }}>
                                Remove
                            </a>
                        </>
                    )
                }
            }
        ]

        const acadColumn = [
            { title: 'Name', key: 'name', dataIndex: 'Name' },
            { title: 'Percentage', key: 'percentage', dataIndex: 'Percentage' },
            {
                title: 'MaximumBacklogs',
                key: 'maximumBacklogs',
                dataIndex: 'MaximumBacklogs'
            },
            {
                title: 'WorkExperience',
                key: 'workExperience',
                dataIndex: 'WorkExperience'
            },
            {
                title: 'Action',
                key: 'action',
                dataIndex: 'action',
                render: (val, record) => {
                    return (
                        <a
                            size="small"
                            onClick={() => {
                                let tempArr = _.reject(this.state.academicRequirements, val => {
                                    return val == record
                                })

                                this.setState({ academicRequirements: tempArr })
                            }}>
                            Remove
                        </a>

                    )
                }
            }
        ]

        const campColumn = [{ title: 'Name', key: 'name', dataIndex: 'campusName' }]

        const pathColumn = [
            { title: 'Path Course', key: 'pathCourse', dataIndex: 'pathCourse' },
            {
                title: 'Path University',
                key: 'pathUniversity',
                dataIndex: 'pathUniversity'
            },
            { title: 'Path Deposit', key: 'pathDeposit', dataIndex: 'pathDeposit' },
            {
                title: 'Path Duration',
                key: 'pathDuration',
                dataIndex: 'pathDuration'
            },
            { title: 'Path Url', key: 'pathUrl', dataIndex: 'pathwayUrl' },
            {
                title: 'Action',
                key: 'action',
                dataIndex: 'key',
                render: (sss, record) => {
                    return (
                        <a
                            onClick={() => {
                                let test = this.state.pathways
                                test = _.reject(test, val => {
                                    return val.key == record.key
                                })

                                this.setState({ pathways: test })
                            }}>
                            Remove
                        </a>
                    )
                }
            }
        ]
        const columns1 = [
            {
                title: 'Qualification',
                key: 'qualification',
                dataIndex: 'qualification',
                searchTextName: '',
                filterRegex: true,
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('qualification', { initialValue: record.qualification ? record.qualification : null })(
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                onChange={(qualification) => {
                                    record.qualification = qualification
                                }}
                            ><Option value={'X'}>X</Option>
                                <Option value={'XII'}>XII</Option>
                                <Option value={'Diploma'}>Diploma</Option>
                                <Option value={'Bachelor Degree'}>Bachelor Degree</Option>
                                <Option value={'Post Graduation'}>Post Graduation</Option>
                            </Select>)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Qualification Status',
                key: 'qualificationStatus',
                dataIndex: 'qualificationStatus',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('qualificationStatus', { initialValue: record.qualificationStatus ? record.qualificationStatus : null })(
                            <InputNumber
                            />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'Grading System',
                key: 'gradingSystem',
                dataIndex: 'gradingSystem',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('gradingSystem', { initialValue: record.gradingSystem ? record.gradingSystem : null })(
                            <InputNumber
                            />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'Score ',
                key: 'score',
                dataIndex: 'score',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('score', { initialValue: record.score ? record.score : null })(
                            <InputNumber
                            />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'Maths ',
                key: 'maths',
                dataIndex: 'maths',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('maths', { initialValue: record.maths ? record.maths : null })(<InputNumber />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'English ',
                key: 'english',
                dataIndex: 'english',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('english', { initialValue: record.english ? record.english : null })(
                            <InputNumber />)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Stream ',
                key: 'stream',
                dataIndex: 'stream',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('stream', { initialValue: record.stream ? record.stream : null })(<Select
                            showSearch={true}
                            style={{ width: '100%' }}
                            dropdownMatchSelectWidth={false}
                            mode={'multiple'}
                        >
                            <Option value={'MEDICAL'}>MEDICAL</Option>
                            <Option value={'NON-MEDICAL'}>NON-MEDICAL</Option>
                            <Option value={'COMMERCE'}>COMMERCE</Option>
                            <Option value={'ARTS'}>ARTS</Option>
                        </Select>)}
                    </Form.Item> : Array.isArray(item) ? item.map(ii => <Tag key={ii}>{ii}</Tag>) : item}</>
                }
            },
            // {
            //     title: 'Major Subjects',
            //     key: 'major',
            //     dataIndex: 'major',
            //     render: (item, record) => {
            //         return <>{record.editable ? <Form.Item>
            //             {getFieldDecorator('major', {initialValue: record.major ? record.major : null})(<Select
            //                 mode="tags"
            //                 style={{width: '100%'}}
            //                 placeholder="Tags Mode"
            //             />)}
            //         </Form.Item> : item && item.map(ii => <Tag>{ii}</Tag>)}</>
            //     }
            // },
            {
                title: 'Backlogs ',
                key: 'backlogs',
                dataIndex: 'backlogs',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('backlogs', { initialValue: record.backlogs ? record.backlogs : null })(
                            <InputNumber />)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Board ',
                key: 'board',
                dataIndex: 'board',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('board', { initialValue: record.board ? record.board : null })(
                            <InputNumber />)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Degree Type ',
                key: 'degreeType',
                dataIndex: 'degreeType',
                render: (item, record) => {
                    let condition = record.qualification == 'Diploma' || record.qualification == 'Bachelor Degree' || record.qualification == 'Post Graduation'
                    return <>{record.editable ?
                        <Form.Item>
                            {getFieldDecorator('degreeType', { initialValue: record.degreeType ? record.degreeType : null })
                                (<Select
                                    showSearch
                                    style={{ width: '100%' }}
                                >{condition ? typeOfDegree[record.qualification].map((val, index) => {
                                    return (
                                        <Option key={index} value={val.value}>
                                            {val.value}
                                        </Option>
                                    )
                                }) : []}
                                </Select>)}
                        </Form.Item> : item}</>
                }
            },
            {
                title: 'Action',
                key: 'operation',
                icon: 'trash',
                fixed: 'right',
                render: (val, record, key) => {
                    return (<React.Fragment>
                        <Tooltip title="Delete">
                            <Button
                                shape="circle"
                                onClick={() => {
                                    let tt = this.state.list
                                    tt = _.reject(tt, val)
                                    this.setState({ list: tt })
                                }}
                                icon="delete"
                                size={'small'}
                            />
                        </Tooltip>
                        {!record.editable && <Tooltip title="Edit">
                            <Button
                                shape="circle"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    let newData = [...this.state.list]
                                    newData = _.map(newData, (item) => {
                                        item.editable = false
                                        return item
                                    })
                                    newData[key] = { ...record, editable: true }
                                    this.setState({ list: newData })

                                }}
                                icon="edit"
                                size={'small'}
                            />
                        </Tooltip>}

                        {record.editable && <a style={{ color: 'orange', marginLeft: '5px' }} onClick={() => {
                            this.onSave(key)
                        }}>Save</a>}
                    </React.Fragment>)
                }
            }
        ]

        const feeColumns = [
            { title: 'Fee Year', dataIndex: 'feeYear' },
            { title: `Fee Amount ${currency ? `(${currency})` : ''}`, dataIndex: 'yearTutionFee' },
            { title: `Scholarship if any ${currency ? `(${currency})` : ''}`, dataIndex: 'yearScholarship' },
            { title: `Material Fee ${currency ? `(${currency})` : ''}`, dataIndex: 'yearMaterialFee' },
            { title: `Uniform Fee ${currency ? `(${currency})` : ''}`, dataIndex: 'yearUniformFee' },
            { title: `Insurance Fee ${currency ? `(${currency})` : ''}`, dataIndex: 'yearInsuranceFee' },
            { title: `Other Fee ${currency ? `(${currency})` : ''}`, dataIndex: 'yearOtherFee' },
            {
                title: 'Action',
                render: (_, record, index) => (
                    <Button
                        type="link"
                        icon="delete"
                        className="text-danger"
                        onClick={() => {
                            const list = [...this.state.tutionFeeList];
                            list.splice(index, 1);
                            this.setState({ tutionFeeList: list });
                        }}
                    />
                )
            }
        ];

        const feeSchema = {
            fields: [
                { label: `Fee Year`, key: 'feeYear', type: 'select', options: [1, 2, 3, 4, 5, 6, 7, 8], onChange: v => setFieldsValue({ feeYear: v }) },
                { label: `Fee Amount ${currency ? `(${currency})` : ''}`, key: 'yearTutionFee' },
                { label: `Scholarship if any ${currency ? `(${currency})` : ''}`, key: 'yearScholarship' },
                { label: `Material Fee ${currency ? `(${currency})` : ''}`, key: 'yearMaterialFee' },
                { label: `Uniform Fee ${currency ? `(${currency})` : ''}`, key: 'yearUniformFee' },
                { label: `Insurance Fee ${currency ? `(${currency})` : ''}`, key: 'yearInsuranceFee' },
                { label: `Other Fee ${currency ? `(${currency})` : ''}`, key: 'yearOtherFee' },
            ]
        }


        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange
        }

        return (
            <PageHeaderWrapper title={courseId ? 'Update Course' : 'Add New Course'}>
                <Form onSubmit={e => e.preventDefault()} style={{ marginTop: 8 }}>
                    <Card bordered={true}>
                        {this.state.showSave ? (
                            <div>
                                <Button
                                    type="primary"
                                    style={{ marginBottom: 10 }}
                                    onClick={this.handleSubmit}
                                    htmlType="button"
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </div>

                        ) : null}

                        <Tabs onChange={this.callback} type="card">
                            {inputs.map((itype, key) => {
                                return (
                                    <TabPane tab={itype.tabTitle} key={key + 1}>
                                        <GetAllFormFields
                                            apiurl={API_URL}
                                            inputSchema={inputs[key]}
                                            refresh={this.refreshFxn}
                                            getFieldDecorator={getFieldDecorator}
                                        />

                                        {key == 4 ? (
                                            <div>
                                                <Card className={style.cardsep}>
                                                    {
                                                        courseId ? this.setState({ showEntryRequirements: true }) :
                                                            <div>
                                                                <label><b>Enquiry Requirements</b></label>
                                                                <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                                                                    <Col span={4}>
                                                                        <Button className={!showEntryRequirements ? 'btn-invoice-active' : ''} onClick={() => this.changeShowEntryRequirement(false)}>Auto Generate</Button>
                                                                    </Col>
                                                                    <Col span={5}>
                                                                        <Button className={showEntryRequirements ? 'btn-invoice-active' : ''} onClick={() => this.changeShowEntryRequirement(true)}>Manually Generate</Button>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                    }

                                                    {showEntryRequirements ?
                                                        <div>
                                                            <h4>English Requirements:</h4>
                                                            <h6>Overall Each band score:</h6>
                                                            <Row>
                                                                <Col span={8}>
                                                                    <Row>
                                                                        <Col span={24}>
                                                                            <Select
                                                                                placeholder={'Choose Exam'}
                                                                                value={this.state.examType}
                                                                                style={{ width: 90 }}
                                                                                className={style.inputNumber}
                                                                                onChange={ei => {

                                                                                    this.setState({ examType: ei }, () => {

                                                                                    })
                                                                                }}>
                                                                                {
                                                                                    this.state.allTestTypes.map(({ testType }) => {
                                                                                        return (
                                                                                            <Option key={testType} value={testType}>{testType}</Option>
                                                                                        )

                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </Col>

                                                                        <Col span={24}>
                                                                            <InputNumber
                                                                                className={style.inputNumber}
                                                                                value={this.state.overall}
                                                                                placeholder={'Overall'}
                                                                                type={'number'}
                                                                                ref={el => (this.overall = el)}
                                                                                onChange={ei => {
                                                                                    this.setState({ overall: ei })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col span={24}>
                                                                            <InputNumber
                                                                                className={style.inputNumber}
                                                                                value={this.state.listening}
                                                                                placeholder={'Listening'}
                                                                                type={'number'}
                                                                                ref={el => (this.listening = el)}
                                                                                onChange={ei => {
                                                                                    this.setState({ listening: ei })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col span={24}>
                                                                            <InputNumber
                                                                                className={style.inputNumber}
                                                                                value={this.state.reading}
                                                                                placeholder={'Reading'}
                                                                                type={'number'}
                                                                                ref={el => (this.reading = el)}
                                                                                onChange={ei => {
                                                                                    this.setState({ reading: ei })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col span={24}>
                                                                            <InputNumber
                                                                                className={style.inputNumber}
                                                                                value={this.state.writing}
                                                                                placeholder={'Writing'}
                                                                                type={'number'}
                                                                                ref={el => (this.writing = el)}
                                                                                onChange={ei => {
                                                                                    this.setState({ writing: ei })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                        <Col span={24}>
                                                                            <InputNumber
                                                                                className={style.inputNumber}
                                                                                value={this.state.speaking}
                                                                                placeholder={'Speaking'}
                                                                                type={'number'}
                                                                                ref={el => (this.speaking = el)}
                                                                                onChange={ei => {
                                                                                    this.setState({ speaking: ei })
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col span={24}>
                                                                            {this.state.editIeltsIndex == 'false' ?
                                                                                <Button
                                                                                    size={'small'}
                                                                                    onClick={() => {
                                                                                        if (this.state.examType) {

                                                                                            this.setState({
                                                                                                ieltsRequirements: [
                                                                                                    ...(this.state.ieltsRequirements || []),
                                                                                                    ...[
                                                                                                        {
                                                                                                            ExamType: this.state.examType,
                                                                                                            Overall: this.state.overall,
                                                                                                            Listening: this.state.listening,
                                                                                                            Reading: this.state.reading,
                                                                                                            Writing: this.state.writing,
                                                                                                            Speaking: this.state.speaking
                                                                                                        }
                                                                                                    ]
                                                                                                ],
                                                                                                examType: '', listening: '', overall: '', reading: '', speaking: '', writing: ''
                                                                                            })
                                                                                            this.overall.value = ''
                                                                                            this.listening.value = ''
                                                                                            this.reading.value = ''
                                                                                            this.writing.value = ''
                                                                                            this.speaking.value = ''
                                                                                        }
                                                                                    }}>
                                                                                    Add
                                                                                </Button>
                                                                                :
                                                                                <Button
                                                                                    size={'small'}
                                                                                    onClick={() => { this.updateIeltsRequirement() }}>
                                                                                    Update
                                                                                </Button>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={16}>
                                                                    <Row>
                                                                        <Col span={24}>
                                                                            <Table
                                                                                bordered={true}
                                                                                pagination={{
                                                                                    defaultPageSize: 2000,
                                                                                    showSizeChanger: false,
                                                                                    showQuickJumper: false
                                                                                }}
                                                                                columns={ieltsColumn}
                                                                                dataSource={this.state.ieltsRequirements}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row style={{ marginTop: 10 }}>
                                                                        <Col span={8}>
                                                                            <h4>IELTS 5.5 (If acceptable in one module)</h4>
                                                                        </Col>
                                                                        <Col span={4}>
                                                                            <input
                                                                                type="radio"
                                                                                name="radioIeltsScoreAcceptable"
                                                                                value='true'
                                                                                onChange={this.changeIeltsScoreAcceptable}
                                                                                checked={this.state.ieltsScoreAcceptable}
                                                                            />
                                                                            Yes
                                                                            <input
                                                                                type="radio"
                                                                                name="radioIeltsScoreAcceptable"
                                                                                value='false'
                                                                                onChange={this.changeIeltsScoreAcceptable}
                                                                                checked={!this.state.ieltsScoreAcceptable}
                                                                            />
                                                                            No
                                                                        </Col>
                                                                    </Row>
                                                                    <Row style={{ marginTop: 20 }}>
                                                                        <Col span={8}>
                                                                            <h4>3 Years Bachelor Degree Acceptable</h4>
                                                                        </Col>
                                                                        <Col span={4}>
                                                                            <input
                                                                                type="radio"
                                                                                name="radioBachelorDegreeAcceptable"
                                                                                value='true'
                                                                                onChange={this.changeBachelorDegreeAcceptable}
                                                                                checked={this.state.bachelorDegreeAcceptable}
                                                                            />
                                                                            Yes
                                                                            <input
                                                                                type="radio"
                                                                                name="radioBachelorDegreeAcceptable"
                                                                                value='notAcceptable'
                                                                                onChange={this.changeBachelorDegreeAcceptable}
                                                                                checked={!this.state.bachelorDegreeAcceptable}
                                                                            />
                                                                            No
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        : null}
                                                </Card>
                                                { }
                                            </div>
                                        ) : null}

                                        {key == 1 && (tutionFeeStructure !== null && tutionFeeStructure !== 'Fixed') && (
                                            <div style={{ marginTop: 30 }}>
                                                {/* <Divider orientation="left">Tuition Fee Breakdown</Divider> */}
                                                <Card>
                                                    <div style={{ marginBottom: 10 }}>
                                                        <Button
                                                            type="primary"
                                                            icon="plus"
                                                            onClick={() => this.setState({ showFeeModal: true })}
                                                        >
                                                            Add Breakdown
                                                        </Button>
                                                    </div>

                                                    <Table
                                                        bordered
                                                        size="small"
                                                        dataSource={tutionFeeList}
                                                        columns={feeColumns}
                                                        pagination={false}
                                                        rowKey={(record, index) => index}
                                                    />
                                                </Card>

                                                <Modal
                                                    destroyOnClose
                                                    title={<span><Icon type="percentage" /> Tution Fee Detail</span>}
                                                    visible={showFeeModal}
                                                    width={900}
                                                    onCancel={() => this.setState({ showFeeModal: false })}
                                                    footer={[
                                                        <Button key="back" onClick={() => this.setState({ showFeeModal: false })}>Cancel</Button>,
                                                        <Button key="submit" type="primary" icon="plus-square" onClick={this.handleFeeDetailSubmit}>Add to Main List</Button>
                                                    ]}
                                                >
                                                    <Form layout="horizontal">
                                                        <GetAllFormFields inputSchema={feeSchema} getFieldDecorator={getFieldDecorator} />
                                                    </Form>
                                                </Modal>
                                            </div>


                                        )}

                                        {key == 2 ? (
                                            <Row>
                                                <Col span={12}>
                                                    <Card>
                                                        <h4>Choose Campus</h4>
                                                        <Table
                                                            rowKey="_id"
                                                            rowSelection={rowSelection}
                                                            columns={campColumn}
                                                            dataSource={this.state.campArr}
                                                        />
                                                        {/* <Table
                                                                                                                            pagination={{
                                                                                                                            defaultPageSize: 2000,
                                                                                                                            showSizeChanger: false,
                                                                                                                            showQuickJumper: false
                                                                                                                            }}
                                                                                                                            bordered={true}
                                                                                                                            rowSelection={rowSelection}
                                                                                                                            columns={campColumn}
                                                                                                                            dataSource={this.state.campArr}
                                                                                                                            /> */}
                                                    </Card>
                                                </Col>
                                                <Col span={12}>
                                                    <Card>
                                                        <h4>Enter Intakes</h4>

                                                        <Row>
                                                            <Col span={24}>
                                                                <Row>
                                                                    <Col span={16}>
                                                                        <MonthPicker
                                                                            className={style.input}
                                                                            placeholder={'Intake'}
                                                                            format={'MMM'}
                                                                            value={this.state.intakeVal}
                                                                            onChange={ei => {
                                                                                this.setState({ intakeVal: moment(ei) })
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                    <Col span={8}>
                                                                        <Button
                                                                            size={'small'}
                                                                            onClick={this.addToIntake}>
                                                                            ADD TO INTAKES
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <List
                                                                            size="small"
                                                                            header={<div>Saved Intakes</div>}
                                                                            bordered
                                                                            dataSource={intakes}
                                                                            renderItem={val => (
                                                                                <List.Item>
                                                                                    <Row style={{ width: 200 }}>
                                                                                        <Col span={12}>
                                                                                            {moment(val).format('MMM')}
                                                                                        </Col>
                                                                                        <Col span={12}>
                                                                                            <a
                                                                                                onClick={() =>
                                                                                                    this.removeIn(val)
                                                                                                }>
                                                                                                Remove
                                                                                            </a>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </List.Item>
                                                                            )}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        ) : null}

                                        {key == 3 ? (
                                            <div>
                                                <Card className={style.cardsep}>
                                                    <h4>Pathways</h4>

                                                    <Row>
                                                        <Col span={8}>
                                                            <Row style={{ marginRight: 10 }}>
                                                                <Col span={24}>
                                                                    <Input
                                                                        className={style.input}
                                                                        ref={el => (this.pathCourse = el)}
                                                                        placeholder={'Pathway Course'}
                                                                        onChange={ei => {
                                                                            this.setState({
                                                                                pathCourse: ei.target.value
                                                                            })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <Input
                                                                        className={style.input}
                                                                        placeholder={'Pathway University'}
                                                                        ref={el => (this.pathUniversity = el)}
                                                                        onChange={ei => {
                                                                            this.setState({
                                                                                pathUniversity: ei.target.value
                                                                            })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <InputNumber
                                                                        className={style.inputNumber}
                                                                        placeholder={'Pathway Deposit'}
                                                                        type={'number'}
                                                                        ref={el => (this.pathDeposit = el)}
                                                                        onChange={ei => {
                                                                            this.setState({ pathDeposit: ei })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <Input
                                                                        className={style.input}
                                                                        placeholder={'Pathway Duration'}
                                                                        ref={el => (this.pathDuration = el)}
                                                                        onChange={ei => {
                                                                            this.setState({
                                                                                pathDuration: ei.target.value
                                                                            })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <Input
                                                                        className={style.input}
                                                                        placeholder={'Pathway Url'}
                                                                        ref={el => (this.pathwayUrl = el)}
                                                                        onChange={ei => {
                                                                            this.setState({
                                                                                pathwayUrl: ei.target.value
                                                                            })
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col span={24}>
                                                                    {' '}
                                                                    <Button
                                                                        size={'small'}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                pathways: [
                                                                                    ...this.state.pathways,
                                                                                    ...[
                                                                                        {
                                                                                            key: moment().unix(),
                                                                                            pathCourse: this.state.pathCourse,
                                                                                            pathUniversity: this.state
                                                                                                .pathUniversity,
                                                                                            pathDeposit: this.state
                                                                                                .pathDeposit,
                                                                                            pathDuration: this.state
                                                                                                .pathDuration,
                                                                                            pathwayUrl: this.state.pathwayUrl
                                                                                        }
                                                                                    ]
                                                                                ]
                                                                            })

                                                                            this.pathCourse.value = ''
                                                                            this.pathUniversity.value = ''
                                                                            this.pathDeposit.value = ''
                                                                            this.pathDuration.value = ''
                                                                            this.pathwayUrl.value = ''
                                                                        }}>
                                                                        ADD TO PATHWAYS
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={16}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Table
                                                                        pagination={{
                                                                            defaultPageSize: 2000,
                                                                            showSizeChanger: false,
                                                                            showQuickJumper: false
                                                                        }}
                                                                        bordered={true}
                                                                        columns={pathColumn}
                                                                        dataSource={this.state.pathways}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </div>
                                        ) : null}
                                        {key == 4 ? (
                                            <div>
                                                <Card className={style.cardsep}>
                                                    {
                                                        courseId ? this.setState({ showQualificationEntry: true }) :
                                                            <div>
                                                                <label><b>Qualification</b></label>
                                                                <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                                                                    <Col span={4}>
                                                                        <Button className={!showQualificationEntry ? 'btn-invoice-active' : ''} onClick={() => this.changeShowQualificationRequirement(false)}>Auto Generate</Button>
                                                                    </Col>
                                                                    <Col span={5}>
                                                                        <Button className={showQualificationEntry ? 'btn-invoice-active' : ''} onClick={() => this.changeShowQualificationRequirement(true)}>Manually Generate</Button>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                    }
                                                    {showQualificationEntry ?
                                                        <div>
                                                            <Quali
                                                                hide={true}
                                                                handleSubmit={data => {

                                                                    let x = [...(this.state.list || []), ...data]
                                                                    this.setState({ list: x })
                                                                }}
                                                            />

                                                            <Table
                                                                size={'small'}
                                                                pagination={{
                                                                    defaultPageSize: 10,
                                                                    showSizeChanger: false,
                                                                    showQuickJumper: false
                                                                }}
                                                                bordered={true}
                                                                columns={columns1}
                                                                dataSource={list}
                                                            />
                                                        </div>
                                                        : null}
                                                </Card>
                                            </div>
                                        ) : null}

                                    </TabPane>
                                )
                            })}
                            <TabPane tab={'Files To Library'} key={inputs.length + 1}>
                                {courseId ? (<Card>
                                    <Row>
                                        <Col span={12}>
                                            <Card title="Add Document">
                                                <div className="gutter-example">
                                                    <Row gutter={16} className={styles['margin-t-md']}>
                                                        <Col className="gutter-row" span={6}>
                                                            <div className="gutter-box">Description</div>
                                                        </Col>
                                                        <Col className="gutter-row" span={18}>
                                                            <div className="gutter-box">
                                                                <TextArea
                                                                    rows="5"
                                                                    placeholder="Description"
                                                                    value={this.state.fileDescription}
                                                                    onChange={e => {
                                                                        this.setState({ fileDescription: e.target.value })
                                                                    }}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="gutter-example">
                                                    <Row gutter={16} className={styles['margin-t-md']}>
                                                        <Col className="gutter-row" span={6}>
                                                            <div className="gutter-box">Branch</div>
                                                        </Col>
                                                        <Col className="gutter-row" span={18}>
                                                            <div className="gutter-box">
                                                                <Select
                                                                    value={this.state.fileBranches}
                                                                    onChange={e => {
                                                                        this.setState({ fileBranches: e })
                                                                    }}>
                                                                    <Option key={1} value={''}>
                                                                        {'Please Choose'}
                                                                    </Option>
                                                                    <Option key={1} value={'Yes'}>
                                                                        {'Yes'}
                                                                    </Option>
                                                                    <Option key={2} value={'No'}>
                                                                        {'No'}
                                                                    </Option>
                                                                </Select>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="gutter-example">
                                                    <Row gutter={16} className={styles['margin-t-md']}>
                                                        <Col className="gutter-row" span={6}>
                                                            <div className="gutter-box">File</div>
                                                        </Col>
                                                        <Col className="gutter-row" span={18}>
                                                            <div className="gutter-box">
                                                                <Upload
                                                                    name={'file'}
                                                                    action={`${API_URL}/filesUploader`}
                                                                    onChange={this.handleChange}
                                                                    onRemove={this.onRemove}>
                                                                    <Button>
                                                                        <Icon type="upload" /> Select File
                                                                    </Button>
                                                                </Upload>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="gutter-example">
                                                    <Row gutter={16} className={styles['margin-t-md']}>
                                                        <Col className="gutter-row" span={6} />
                                                        <Col className="gutter-row" span={6}>
                                                            <Button type="primary" onClick={this.saveFiles}>
                                                                Upload Now
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Card>
                                        </Col>
                                        <Col span={12}>
                                            <Card title="Previous Documents">
                                                <List
                                                    className={styles['demo-loadmore-list']}
                                                    size="small"
                                                    header={<div>Total : {this.state.arr.length}</div>}
                                                    bordered
                                                    dataSource={this.state.arr || []}
                                                    renderItem={item => (
                                                        <List.Item key={item.id}>
                                                            <List.Item.Meta
                                                                title={
                                                                    <a
                                                                        href={item.link}
                                                                        style={{
                                                                            color: 'orange',
                                                                            textDecorationLine: 'underline'
                                                                        }}
                                                                        target={'_blank'}>
                                                                        {item.name}
                                                                    </a>
                                                                }
                                                                description={
                                                                    <div style={{ fontSize: 13 }}>
                                                                        {item.description}<br></br>
                                                                        <div>{item.uploadedBy && `${moment(item.uploadedBy.time).format('Do MMMM, YYYY')} [${moment(item.uploadedBy.time).format('hh:mm')}]`}</div>
                                                                        <div>{item.uploadedBy && `[${item.uploadedBy.name}]`}</div>
                                                                    </div>

                                                                }
                                                            />
                                                            <div style={{ fontSize: 12 }}>
                                                                Branch :{item.branch}
                                                            </div>
                                                            <div>
                                                                <Tooltip title="Delete">
                                                                    <Popconfirm
                                                                        title="Are you sure to delete?"
                                                                        onConfirm={() => this.handleDelete(item.files[0]._id)}>
                                                                        <Button
                                                                            style={{ marginLeft: '5px' }}
                                                                            size={'small'}
                                                                            shape="circle"
                                                                            icon="delete" />
                                                                    </Popconfirm>
                                                                </Tooltip>
                                                            </div>
                                                        </List.Item>
                                                    )}
                                                />
                                            </Card>
                                        </Col>
                                    </Row>
                                </Card>) : <Card><h3>Course must be saved before uploading a file</h3></Card>}

                            </TabPane>
                        </Tabs>
                    </Card>
                </Form>
            </PageHeaderWrapper>
        )
    }

}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCourse)
